var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4247 12.2124C25.1168 12.2124 25.6969 11.9783 26.165 11.5102C26.6331 11.042 26.8672 10.4619 26.8672 9.7699C26.8672 9.07786 26.6331 8.49778 26.165 8.02963C25.6969 7.56149 25.1168 7.32742 24.4247 7.32742C23.7327 7.32742 23.1526 7.56149 22.6845 8.02963C22.2163 8.49778 21.9823 9.07786 21.9823 9.7699C21.9823 10.4619 22.2163 11.042 22.6845 11.5102C23.1526 11.9783 23.7327 12.2124 24.4247 12.2124ZM21.9823 31.7522H26.8672V17.0973H21.9823V31.7522ZM0 48.8495V4.88495C0 3.54159 0.478318 2.39159 1.43495 1.43495C2.39159 0.478318 3.54159 0 4.88495 0H43.9645C45.3079 0 46.4579 0.478318 47.4145 1.43495C48.3712 2.39159 48.8495 3.54159 48.8495 4.88495V34.1946C48.8495 35.538 48.3712 36.688 47.4145 37.6446C46.4579 38.6013 45.3079 39.0796 43.9645 39.0796H9.7699L0 48.8495ZM7.69379 34.1946H43.9645V4.88495H4.88495V36.9424L7.69379 34.1946Z",
    fill: "#CA005D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatInfo);
export default __webpack_public_path__ + "static/media/chat_info.06cae4a59908bdde0428fc388d6633da.svg";
export { ForwardRef as ReactComponent };